import {createFileRoute} from '@tanstack/react-router'
import RyderCupCreate from "../../../rydercup/RyderCupCreate.tsx";

export const Route = createFileRoute('/_app/rydercup/create')({
    component: RouteComponent,
})

function RouteComponent() {
    return <RyderCupCreate />
}
